<div class="preloading_main_div" *ngIf="preloadingFlag">
    <span class="loader"></span>
</div>
<div class="cotum_loader">
    <div class="step1_loader">
        <div>
            <div style="text-align: center; height: 80px;">&nbsp;</div>

            <div
                style="text-align: center; margin-top: 13px;font-family: 'Inter', sans-serif; font-weight: 600; font-size: 18px;">
                Congratulations!</div>

            <div style="text-align: center;margin-top: 15px;font-family: 'IBM Plex Sans', sans-serif;font-size: 16px;font-weight: 500;" *ngIf="!isApproved">
                Your free listing is under review.<br />
                Once approved, your restaurant will be automatically showcased <br /> to the most relevant potential
                customers on Foodbud consumer app.
            </div>
            <div style="text-align: center;margin-top: 15px;font-family: 'IBM Plex Sans', sans-serif;font-size: 16px;font-weight: 500;" *ngIf="isApproved">
                Your restaurant details have been successfully updated.<br />
                The latest information is now visible on the Foodbud consumer app, <br /> helping more customers discover your business.
            </div>

            <div style="margin-top: 4rem;">
                <div
                    style="text-align: center;font-family: 'Inter', sans-serif;font-weight: 400;font-size: 14px; margin-bottom: 10px;">
                    The Foodbud Restaurant discovery app is available on both Play store and App store.
                </div>

                <div style="display: flex;justify-content: center; gap:2px;">
                    <img src="../../../assets/img/play_store.avif" alt="" style="cursor: pointer;" (click)="openStore('https://play.google.com/store/apps/details?id=com.cms.foodbudapp')">
                    <img src="../../../assets/img/app_store.avif" alt="" style="cursor: pointer;" (click)="openStore('https://apps.apple.com/in/app/foodbud/id1584641741')">
                </div>
            </div>

            <div style="margin-top: 6rem;font-family: 'IBM Plex Sans', sans-serif;font-size: 14px;text-align: center;font-weight: 500;" *ngIf="!isApproved">Want to download sample menu QR code? <span style="color: #4790a4;cursor: pointer;font-weight: 600;" (click)="downLoadQrWeb()">DOWNLOAD</span> </div>
        </div>
    </div>
</div>



<style>
    .cotum_loader {
        position: fixed;
        top: 0;
        height: 100vh;
        width: 100vw;
        background: #237C96;
        z-index: 11;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
    }


    .step1_loader {
        background: #FFFFFF;
        border-radius: 12px;
        padding: 28px;
    }

    .preloading_main_div {
        position: fixed;
        top: 0;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        background: #000000b3;
        display: flex;
        justify-content: center;
        align-items: center;

        .loader {
            display: inline-block;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            background-color: #fff;
            box-shadow: 32px 0 #fff, -32px 0 #fff;
            position: relative;
            animation: flash 0.5s ease-out infinite alternate;
        }

        @keyframes flash {
            0% {
                background-color: #FFF2;
                box-shadow: 32px 0 #FFF2, -32px 0 #FFF;
            }

            50% {
                background-color: #FFF;
                box-shadow: 32px 0 #FFF2, -32px 0 #FFF2;
            }

            100% {
                background-color: #FFF2;
                box-shadow: 32px 0 #FFF, -32px 0 #FFF2;
            }
        }

    }
</style>